__turbopack_context__.v({
  "name": "UserIcon-module-scss-module__v3XXda__name",
  "root": "UserIcon-module-scss-module__v3XXda__root",
});
